import { useState, useCallback } from 'react';

const useAcceptWithSmartFit = () => {
  const [smartFitState, setSmartFitState] = useState(null);

  const openSmartFitForAccept = useCallback(
    ({ resourceRequest, resourceUser, allocationChartRef }) => {
      setSmartFitState({
        resourceRequest,
        resourceUser: { ...resourceUser, id: resourceUser.uri },
        allocationChartRef
      });
    },
    []
  );

  const closeSmartFit = useCallback(() => setSmartFitState(null), []);

  return {
    isSmartFitOpen: Boolean(smartFitState),
    smartFitState,
    openSmartFitForAccept,
    closeSmartFit
  };
};

export default useAcceptWithSmartFit;
